import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button, Card, Modal } from 'react-bootstrap'
import axios from 'axios'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import { BASE_URL } from '../constants'
import { theme } from '../theme/theme'



const Createbooking = ({ onBookingCreated }) => {
  const navigate = useNavigate()
  const [booking, setBooking] = useState({
    user_id: '1234',
    site_name: '',
    plot_number: '',
    plot_id: '',
    customer_id: '',
    broker_id: '',
    actual_price: '',
    final_price: '',
    booking_price_in_words: '',
    plot_size: '',
    discount_price: '',
    booking_price: '',
    booking_payment_status: '',
    booking_status: 'BOOKED',
    due_date: '',
    booking_date: '',
    payment_method: '',
    online_transaction_number: '',
  })

  const [finalDiscount, setFinalDiscount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [siteNames, setSiteNames] = useState([])
  const [sitePlots, setSitePlots] = useState([])
  const [customers, setCustomers] = useState([])
  const [brokers, setBrokers] = useState([])
  const [showPreview, setShowPreview] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [bookedId, setBookedId] = useState(null)

  useEffect(() => {
    const token = Cookies.get('authToken')
    if (!token) window.location.href = '/login'
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      const token = Cookies.get('authToken')
      try {
        const [sitesRes, customersRes, brokersRes] = await Promise.all([
          axios.get(`${BASE_URL}/sites`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${BASE_URL}/customer/search`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${BASE_URL}/brokers/search`, { headers: { Authorization: `Bearer ${token}` } }),
        ])
        setSiteNames(sitesRes.data.data)
        setCustomers(customersRes.data.data)
        setBrokers(brokersRes.data.data)
      } catch (err) {
        toast.error('Failed to fetch data')
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  const validBookingPaymentStatus = ['COMPLETE', 'PENDING', 'FAILED']
  const validPaymentMethod = ['ONLINE', 'CASH', 'CHEQUE']

  const inputHandler = (e) => {
    const { name, value } = e.target
    setBooking((prev) => ({ ...prev, [name]: value }))
  }

  const handleSiteSelect = async (e) => {
    const selectedSiteId = Number(e.target.value)
    setBooking({ ...booking, site_name: selectedSiteId, plot_number: '', plot_id: '' })
    setLoading(true)
    const token = Cookies.get('authToken')
    try {
      const response = await axios.get(`${BASE_URL}/site/plots?id=${selectedSiteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      const availablePlots = response.data.data.filter((plot) => plot.status === 'AVAILABLE')
      setSitePlots(availablePlots.length ? availablePlots : [{ id: 0, plot_number: 'No plot available', disabled: true }])
    } catch {
      toast.error('Failed to fetch plots for selected site')
    } finally {
      setLoading(false)
    }
  }

  const handlePlotSelect = (e) => {
    const selectedPlotId = Number(e.target.value)
    const selectedPlot = sitePlots.find((plot) => plot.id === selectedPlotId)
    if (selectedPlot) {
      setBooking({
        ...booking,
        plot_number: selectedPlot.plot_number,
        plot_id: selectedPlot.id,
        plot_size: selectedPlot.plot_size,
        actual_price: selectedPlot.price,
        final_price: selectedPlot.price,
      })
      setFinalDiscount(selectedPlot.price)
    }
  }

  const handleDiscount = (e) => {
    const discount = e.target.value || 0
    setBooking((prev) => ({ ...prev, final_price: finalDiscount - discount, discount_price: discount }))
  }

  const convertNumberToWords = (num) => {
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine']
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen']
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']

    const convertHundreds = (n) => {
      if (n < 10) return ones[n]
      if (n < 20) return teens[n - 10]
      if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 > 0 ? ' ' + ones[n % 10] : '')
      return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 > 0 ? ' ' + convertHundreds(n % 100) : '')
    }

    if (num === 0) return 'Zero Only'

    let words = ''
    const crore = Math.floor(num / 10000000)
    const lakh = Math.floor((num % 10000000) / 100000)
    const thousand = Math.floor((num % 100000) / 1000)
    const remainder = num % 1000

    if (crore > 0) words += convertHundreds(crore) + ' Crore '
    if (lakh > 0) words += convertHundreds(lakh) + ' Lakh '
    if (thousand > 0) words += convertHundreds(thousand) + ' Thousand '
    if (remainder > 0) words += convertHundreds(remainder)

    return words.trim() + ' Only'
  }

  useEffect(() => {
    const priceInWords = convertNumberToWords(Number(booking.booking_price))
    setBooking((prev) => ({ ...prev, booking_price_in_words: priceInWords }))
  }, [booking.booking_price])

  const togglePreview = () => setShowPreview(!showPreview)

  const submitForm = async (e) => {
    e.preventDefault()
    setLoading(true)
    const token = Cookies.get('authToken')

    if (!booking.site_name || !booking.plot_id || !booking.customer_id || !booking.broker_id) {
      toast.error('Please fill all mandatory fields')
      setLoading(false)
      return
    }

    if (!validPaymentMethod.includes(booking.payment_method) || !validBookingPaymentStatus.includes(booking.booking_payment_status)) {
      toast.error('Please select valid payment method and status')
      setLoading(false)
      return
    }

    try {
      const response = await axios.post(`${BASE_URL}/booking/create`, booking, {
        headers: { Authorization: `Bearer ${token}` },
      })
      const bookingId = response?.data?.bookingId || response?.data?.data?.id
      if (bookingId) {
        setBookedId(bookingId)
        setShowModal(true)
      } else {
        toast.success(response.data.message || 'Booking created successfully')
      }
    } catch (err) {
      toast.error(err.response?.data?.message || err.message || 'Failed to create booking')
    } finally {
      setLoading(false)
    }
  }

  const handleModalClose = () => {
    setShowModal(false)
    if (bookedId) navigate(`/BookingPrintpage/${bookedId}`)
  }

  return (
    <Container className="pb-3" style={{fontFamily: theme.font.family }}>
      {!showPreview ? (
        <Form onSubmit={submitForm} className="mx-auto p-3 rounded-3" style={{  backgroundColor:theme.colors.background }}>
          <p className="mb-4 fw-bold" style={{ color: theme.colors.primary, borderBottom: '2px solid #ccc', paddingBottom: '8px' , fontSize: '1.5rem'}}>Create New Booking</p>

          {/* Site & Plot Selection */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>Site Name *</Form.Label>
              <Form.Select name="site_name" value={booking.site_name} onChange={handleSiteSelect} style={{ borderRadius: '6px' }}>
                <option value="">Select site</option>
                {siteNames.map(site => <option key={site.id} value={site.id}>{site.name}</option>)}
              </Form.Select>
            </Col>
            <Col md={6}>
              <Form.Label>Plot Number *</Form.Label>
              <Form.Select name="plot_number" value={booking.plot_id} onChange={handlePlotSelect} style={{ borderRadius: '6px' }}>
                {sitePlots.length ? <option value="">Select a plot</option> : <option value="0">No plots available</option>}
                {sitePlots.map(plot => <option key={plot.id} value={plot.id}>{plot.plot_number}</option>)}
              </Form.Select>
            </Col>
          </Row>

          {/* Plot Size & Customer */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>Plot Size</Form.Label>
              <Form.Control type="text" name="plot_size" value={booking.plot_size} disabled style={{ borderRadius: '6px' }} />
            </Col>
            <Col md={6}>
              <Form.Label>Customer Name *</Form.Label>
              <Form.Select name="customer_id" value={booking.customer_id} onChange={inputHandler} style={{ borderRadius: '6px' }}>
                <option value="">Select Customer</option>
                {customers.length ? customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>) : <option>No customers available</option>}
              </Form.Select>
            </Col>
          </Row>

          {/* Associate & Pricing */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>Associate Name *</Form.Label>
              <Form.Select name="broker_id" value={booking.broker_id} onChange={inputHandler} style={{ borderRadius: '6px' }}>
                <option value="">Select Associate</option>
                {brokers.map(b => <option key={b.id} value={b.broker_id}>{b.name}</option>)}
              </Form.Select>
            </Col>
            <Col md={6}>
              <Form.Label>Actual Price</Form.Label>
              <Form.Control type="number" name="actual_price" value={booking.actual_price} disabled style={{ borderRadius: '6px' }} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>Discount</Form.Label>
              <Form.Control type="number" name="discount_price" value={booking.discount_price} onChange={handleDiscount} style={{ borderRadius: '6px' }} />
            </Col>
            <Col md={6}>
              <Form.Label>Final Price</Form.Label>
              <Form.Control type="number" name="final_price" value={booking.final_price} disabled style={{ borderRadius: '6px' }} />
            </Col>
          </Row>

          {/* Booking Amount & Status */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>Booking Amount *</Form.Label>
              <Form.Control type="number" name="booking_price" value={booking.booking_price} onChange={inputHandler} style={{ borderRadius: '6px' }} />
            </Col>
            <Col md={6}>
              <Form.Label>Booking Status</Form.Label>
              <Form.Control name="booking_status" value={booking.booking_status} disabled style={{ borderRadius: '6px' }} />
            </Col>
          </Row>

          {/* Booking Amount in Words */}
          <Row className="mb-3">
            <Col md={12}>
              <Form.Label>Booking Amount in Words</Form.Label>
              <Form.Control as="textarea" name="booking_price_in_words" value={booking.booking_price_in_words} disabled style={{ borderRadius: '6px' }} />
            </Col>
          </Row>

          {/* Payment Method & Transaction */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>Payment Method *</Form.Label>
              <Form.Select name="payment_method" value={booking.payment_method} onChange={inputHandler} style={{ borderRadius: '6px' }}>
                <option value="">SELECT</option>
                <option value="ONLINE">ONLINE</option>
                <option value="CASH">CASH</option>
                <option value="CHEQUE">CHEQUE</option>
              </Form.Select>
            </Col>
            <Col md={6}>
              <Form.Label>{booking.payment_method === 'CASH' ? 'Not Mandatory' : booking.payment_method === 'CHEQUE' ? 'Cheque Number *' : 'Online Transaction Number *'}</Form.Label>
              <Form.Control
                type="text"
                name="online_transaction_number"
                value={booking.online_transaction_number}
                onChange={inputHandler}
                placeholder={booking.payment_method === 'CASH' ? '' : booking.payment_method === 'CHEQUE' ? 'Enter Cheque Number' : 'Enter Transaction Number'}
                disabled={booking.payment_method === 'CASH'}
                style={{ borderRadius: '6px' }}
              />
            </Col>
          </Row>

          {/* Payment Status & Booking Dates */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>Booking Payment Status *</Form.Label>
              <Form.Select name="booking_payment_status" value={booking.booking_payment_status} onChange={inputHandler} style={{ borderRadius: '6px' }}>
                <option value="">SELECT</option>
                <option value="COMPLETE">COMPLETE</option>
                <option value="PENDING">PENDING</option>
                <option value="FAILED">FAILED</option>
              </Form.Select>
            </Col>
            <Col md={6}>
              <Form.Label>Booking Date *</Form.Label>
              <Form.Control type="date" name="booking_date" value={booking.booking_date} onChange={inputHandler} style={{ borderRadius: '6px' }} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>Due Date</Form.Label>
              <Form.Control type="date" name="due_date" value={booking.due_date} onChange={inputHandler} style={{ borderRadius: '6px' }} />
            </Col>
          </Row>

          {/* Buttons */}
          <div className="d-flex gap-2 mt-4 me-0 justify-content-end">
            <Button onClick={togglePreview} style={{ backgroundColor: '#8E9B56', border: 'none', color: '#fff', borderRadius: '6px' }}>Show Preview</Button>
            <Button type="submit" style={{ backgroundColor: '#4D5C2B', border: 'none', color: '#fff', borderRadius: '6px' }}>Create Booking</Button>
          </div>
        </Form>
      ) : (
        // Booking Preview Card
        <Card className=" ms-2 mx-auto rounded-3">
          <Card.Header style={{ backgroundColor: '#4D5C2B', color: '#fff', fontWeight: 'bold' }}>Booking Preview</Card.Header>
          <Card.Body>
            {Object.entries(booking).map(([key, value]) => (
              <p key={key}><strong>{key.replace(/_/g, ' ')}: </strong>{value || 'N/A'}</p>
            ))}
          </Card.Body>
          <Card.Footer className="d-flex justify-content-between">
            <Button onClick={togglePreview} style={{ backgroundColor: '#8E9B56', border: 'none', color: '#fff' }}>Edit Booking</Button>
            <Button onClick={submitForm} style={{ backgroundColor: '#4D5C2B', border: 'none', color: '#fff' }}>Confirm Booking</Button>
          </Card.Footer>
        </Card>
      )}

      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-center text-success">Booking Confirmed!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your booking has been successfully confirmed. You can now review the plot details.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleModalClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default Createbooking
